export default {
  namespaced: true,
  state: {
    info: null,
    token: null,
    permissions: [],
  },
  mutations: {
    info(state, value) {
      state.info = value;
    },
    token(state, value) {
      state.token = value;
    },
    permissions(state, value) {
      state.permissions = value;
    },
  },
};
